"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALES = exports.LANGUAGES = void 0;
var LANGUAGES;
(function (LANGUAGES) {
    LANGUAGES["ca"] = "ca";
    LANGUAGES["cs"] = "cs";
    LANGUAGES["de"] = "de";
    LANGUAGES["en"] = "en";
    LANGUAGES["es"] = "es";
    LANGUAGES["eu"] = "eu";
    LANGUAGES["fr"] = "fr";
    LANGUAGES["gl"] = "gl";
    LANGUAGES["id"] = "id";
    LANGUAGES["it"] = "it";
    LANGUAGES["ja"] = "ja";
    LANGUAGES["jv"] = "jv";
    LANGUAGES["ko"] = "ko";
    LANGUAGES["ml"] = "ml";
    LANGUAGES["ms"] = "ms";
    LANGUAGES["nl"] = "nl";
    LANGUAGES["pa"] = "pa";
    LANGUAGES["pl"] = "pl";
    LANGUAGES["pt"] = "pt";
    LANGUAGES["ro"] = "ro";
    LANGUAGES["ta"] = "ta";
    LANGUAGES["te"] = "te";
    LANGUAGES["th"] = "th";
    LANGUAGES["zh"] = "zh";
})(LANGUAGES = exports.LANGUAGES || (exports.LANGUAGES = {}));
var LOCALES;
(function (LOCALES) {
    LOCALES[LOCALES["ca-ES"] = 0] = "ca-ES";
    LOCALES[LOCALES["cs-CZ"] = 1] = "cs-CZ";
    LOCALES[LOCALES["de-AQ"] = 2] = "de-AQ";
    LOCALES[LOCALES["de-AT"] = 3] = "de-AT";
    LOCALES[LOCALES["de-CH"] = 4] = "de-CH";
    LOCALES[LOCALES["de-DE"] = 5] = "de-DE";
    LOCALES[LOCALES["en-AQ"] = 6] = "en-AQ";
    LOCALES[LOCALES["en-AT"] = 7] = "en-AT";
    LOCALES[LOCALES["en-CA"] = 8] = "en-CA";
    LOCALES[LOCALES["en-CH"] = 9] = "en-CH";
    LOCALES[LOCALES["en-CZ"] = 10] = "en-CZ";
    LOCALES[LOCALES["en-DE"] = 11] = "en-DE";
    LOCALES[LOCALES["en-ES"] = 12] = "en-ES";
    LOCALES[LOCALES["en-FR"] = 13] = "en-FR";
    LOCALES[LOCALES["en-GB"] = 14] = "en-GB";
    LOCALES[LOCALES["en-ID"] = 15] = "en-ID";
    LOCALES[LOCALES["en-JA"] = 16] = "en-JA";
    LOCALES[LOCALES["en-KR"] = 17] = "en-KR";
    LOCALES[LOCALES["en-MY"] = 18] = "en-MY";
    LOCALES[LOCALES["en-NL"] = 19] = "en-NL";
    LOCALES[LOCALES["en-NZ"] = 20] = "en-NZ";
    LOCALES[LOCALES["en-PL"] = 21] = "en-PL";
    LOCALES[LOCALES["en-PT"] = 22] = "en-PT";
    LOCALES[LOCALES["en-RO"] = 23] = "en-RO";
    LOCALES[LOCALES["en-SG"] = 24] = "en-SG";
    LOCALES[LOCALES["en-TH"] = 25] = "en-TH";
    LOCALES[LOCALES["en-TW"] = 26] = "en-TW";
    LOCALES[LOCALES["en-US"] = 27] = "en-US";
    LOCALES[LOCALES["en-ZA"] = 28] = "en-ZA";
    LOCALES[LOCALES["es-AQ"] = 29] = "es-AQ";
    LOCALES[LOCALES["es-ES"] = 30] = "es-ES";
    LOCALES[LOCALES["eu-ES"] = 31] = "eu-ES";
    LOCALES[LOCALES["fr-AQ"] = 32] = "fr-AQ";
    LOCALES[LOCALES["fr-CA"] = 33] = "fr-CA";
    LOCALES[LOCALES["fr-CH"] = 34] = "fr-CH";
    LOCALES[LOCALES["fr-FR"] = 35] = "fr-FR";
    LOCALES[LOCALES["gl-ES"] = 36] = "gl-ES";
    LOCALES[LOCALES["id-ID"] = 37] = "id-ID";
    LOCALES[LOCALES["it-AQ"] = 38] = "it-AQ";
    LOCALES[LOCALES["it-CH"] = 39] = "it-CH";
    LOCALES[LOCALES["ja-JA"] = 40] = "ja-JA";
    LOCALES[LOCALES["jv-ID"] = 41] = "jv-ID";
    LOCALES[LOCALES["ko-KR"] = 42] = "ko-KR";
    LOCALES[LOCALES["ml-MY"] = 43] = "ml-MY";
    LOCALES[LOCALES["ms-MY"] = 44] = "ms-MY";
    LOCALES[LOCALES["ms-SG"] = 45] = "ms-SG";
    LOCALES[LOCALES["nl-ID"] = 46] = "nl-ID";
    LOCALES[LOCALES["nl-NL"] = 47] = "nl-NL";
    LOCALES[LOCALES["pa-MY"] = 48] = "pa-MY";
    LOCALES[LOCALES["pl-PL"] = 49] = "pl-PL";
    LOCALES[LOCALES["pt-PT"] = 50] = "pt-PT";
    LOCALES[LOCALES["ro-RO"] = 51] = "ro-RO";
    LOCALES[LOCALES["ta-MY"] = 52] = "ta-MY";
    LOCALES[LOCALES["ta-SG"] = 53] = "ta-SG";
    LOCALES[LOCALES["te-MY"] = 54] = "te-MY";
    LOCALES[LOCALES["th-MY"] = 55] = "th-MY";
    LOCALES[LOCALES["th-TH"] = 56] = "th-TH";
    LOCALES[LOCALES["zh-MY"] = 57] = "zh-MY";
    LOCALES[LOCALES["zh-SG"] = 58] = "zh-SG";
    LOCALES[LOCALES["zh-TW"] = 59] = "zh-TW";
})(LOCALES = exports.LOCALES || (exports.LOCALES = {}));
//# sourceMappingURL=locale.js.map